var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgWithdrawal = function SvgWithdrawal(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M18.96 16.78v-1.03H9.48c-.6 0-1.1-.2-1.5-.61-.42-.4-.62-.9-.62-1.5V6.6c0-.59.2-1.08.62-1.5.4-.4.9-.6 1.5-.6h9.48V3.47a2 2 0 0 0-.64-1.46 2.05 2.05 0 0 0-1.48-.63H2.12c-.59 0-1.1.2-1.5.6-.41.41-.62.9-.62 1.5v13.3c0 .58.2 1.08.62 1.48.4.41.91.61 1.5.61h14.72c.56 0 1.05-.2 1.48-.63a2 2 0 0 0 .64-1.46Z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M10.73 13.65c-.69 0-1.25-.56-1.25-1.25V7.85c0-.69.56-1.25 1.25-1.25h8.02c.7 0 1.25.56 1.25 1.25v4.55c0 .7-.56 1.25-1.25 1.25h-8.02Zm4.9-2.27c-.32.29-.69.43-1.12.43-.42 0-.8-.14-1.1-.43-.32-.3-.48-.67-.48-1.13 0-.45.16-.83.47-1.12.31-.3.69-.44 1.11-.44.43 0 .8.15 1.12.44.3.3.46.67.46 1.12 0 .46-.15.83-.46 1.13Z"
  }))));
};
export default SvgWithdrawal;